module.exports = __webpack_public_path__ + "img/img18.6cafe24a.png";